/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

import React, { PureComponent } from "react";
import { compose, withProps } from "recompose";
import { GoogleMap, withGoogleMap, withScriptjs } from "react-google-maps";
import { mapStyle } from "./MapStyleConfig";
import AllPolygons from "./AllPolygons";
import LiveVehicle from "./LiveVehicle";
import ReplayVehicle from "./ReplayVehicle";
import PolygonInfo from "./PolygonInfo";

class Map extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedPolygon: {
        visible: false,
        id: null,
        propertyId: null,
        propertyName: null,
        lat: null,
        lng: null,
      },
    };
  }

  // open info window when click on any geometry
  openInfoWindow = (id, propertyId, propertyName, center) => {
    const updatedSelectedPolygon = {
      ...this.state.selectedPolygon,
      id: id,
      visible: true,
      propertyId: propertyId,
      propertyName: propertyName,
      lat: center.lat,
      lng: center.lng,
    };
    this.setState({ selectedPolygon: updatedSelectedPolygon });
  };

  // close info window when click on cross icon in info window
  closeInfoWindow = () => {
    const updatedSelectedPolygon = {
      ...this.state.selectedPolygon,
      id: null,
      visible: false,
      propertyId: null,
      propertyName: null,
      lat: null,
      lng: null,
    };
    this.setState({ selectedPolygon: updatedSelectedPolygon });
  };

  render() {

    // set dynamic changes map center
    let centerLat = 33.81486511230469;
    let centerLng = -117.85834503173828;
    if (this.props.centerDecider && this.props.isVehicleDetailsVisible) {
      centerLat = this.props.detailCenterCoordinates.detailLat
        ? this.props.detailCenterCoordinates.detailLat
        : this.props.viewportCenter.lat;
      centerLng = this.props.detailCenterCoordinates.detailLng
        ? this.props.detailCenterCoordinates.detailLng
        : this.props.viewportCenter.lng;
    } else if (this.props.centerDecider) {
      centerLat = this.props.selectedVehicle.lat;
      centerLng = this.props.selectedVehicle.lng;
    } else {
      if (this.props.viewportCenter.lat && this.props.viewportCenter.lng) {
        centerLat = this.props.viewportCenter.lat;
        centerLng = this.props.viewportCenter.lng;
      }
    }

    return (
      <GoogleMap
        ref={(mapRef) => (global.mapRef = mapRef)}
        onBoundsChanged={this.props.centerChanged}
        defaultOptions={{ styles: mapStyle }}
        defaultZoom={10}
        options={{ fullscreenControl: false }}
        center={{ lat: centerLat, lng: centerLng }}>
        {!this.props.isVehicleDetailsVisible && (
          <LiveVehicle
            coordinates={this.props.coordinates}
            selectVehicle={this.props.selectVehicle}
            selectedKey={this.props.selectedVehicle.key}
          />
        )}

        {this.props.isVehicleDetailsVisible && (
          <ReplayVehicle coordinates={this.props.replayCoordinates} />
        )}

        <AllPolygons
          showTodaysGeometry={!this.props.isVehicleDetailsVisible}
          openInfoWindow={this.openInfoWindow}
        />

        {this.state.selectedPolygon.visible &&
          !this.props.isVehicleDetailsVisible && (
            <PolygonInfo
              pos={{
                lat: this.state.selectedPolygon.lat,
                lng: this.state.selectedPolygon.lng,
              }}
              onCloseClick={this.closeInfoWindow}
              propertyName={this.state.selectedPolygon.propertyName}
              propertyId={this.state.selectedPolygon.propertyId}
            />
          )}
      </GoogleMap>
    );
  }
}

export default compose(
  withProps({
    googleMapURL:
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyBnvRm7g7qHl47C3slFh-YYr8onuu84Ih4&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: (
      <div
        style={{
          height: `100vh`,
          width: `100%`,
        }}
      />
    ),
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)(Map);
